class ProductCharacterCarousel extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.viewport = this.querySelector('[data-character-viewport]');
    this.products = [...this.querySelectorAll('[data-character-product]')];
    if (!this.viewport || this.products.length < 2) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.hovered = false;
    this.pressed = false;
    this.visible = false;
    this.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse') this.hovered = true;
      this.schedule();
    }, { signal });
    this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
    this.addEventListener('pointerdown', () => { this.pressed = true; this.schedule(); }, { signal, passive: true });
    document.addEventListener('pointerup', () => { this.pressed = false; this.schedule(); }, { signal, passive: true });
    document.addEventListener('pointercancel', () => { this.pressed = false; this.schedule(); }, { signal });
    this.addEventListener('focusin', () => this.schedule(), { signal });
    this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), { signal });
    this.viewport.addEventListener('scroll', () => this.schedule(), { signal, passive: true });
    this.motion.addEventListener('change', () => this.schedule(), { signal });
    document.addEventListener('visibilitychange', () => this.schedule(), { signal });
    this.resizeObserver = new ResizeObserver(() => this.schedule());
    this.resizeObserver.observe(this.viewport);
    this.visibilityObserver = new IntersectionObserver(entries => {
      this.visible = entries.some(entry => entry.isIntersecting);
      this.schedule();
    });
    this.visibilityObserver.observe(this);
  }

  schedule() {
    clearTimeout(this.timer);
    const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
    if (!this.isConnected || this.dataset.autoplay !== 'true' || this.motion.matches || !this.visible || this.hovered || this.pressed || document.hidden || this.contains(document.activeElement) || maximum < 2) return;
    this.timer = setTimeout(() => this.advance(), 5000);
  }

  advance() {
    const position = Math.max(0, this.viewport.scrollLeft);
    const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
    const start = this.products[0].offsetLeft;
    const next = this.products.find(product => product.offsetLeft - start > position + 2);
    const target = position >= maximum - 2 || !next ? 0 : Math.min(maximum, next.offsetLeft - start);
    this.viewport.scrollTo({ left: target, behavior: 'smooth' });
    this.schedule();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    this.controller?.abort();
    this.controller = null;
    this.resizeObserver?.disconnect();
    this.visibilityObserver?.disconnect();
  }
}

if (!customElements.get('product-character-carousel')) customElements.define('product-character-carousel', ProductCharacterCarousel);
